// eslint-disable-next-line no-restricted-imports
import { LegalBankAccountFragment } from 'api/generated/graphql';
import { parseCountryEntity } from 'api/helpers/parseCountryEntity';
import { LegalClientBankAccountEntity } from 'api/types/entity/legal/legalClientBankAccountEntity';
import { lodash } from 'helpers';
import { Maybe } from 'types/maybe';

export const parseLegalClientBankAccounts = (
  bankAccounts: Maybe<LegalBankAccountFragment>[] | undefined | null
): LegalClientBankAccountEntity[] | undefined =>
  bankAccounts
    ? lodash.compact(bankAccounts).map((v) => ({
        swiftCode: v.swiftCode,
        country: parseCountryEntity(v.country),
        hasPermanentManagementInCountry: v.hasPermanentManagementInCountry,
        onTerritoryWithNoAML_CFT: v.onTerritoryWithNoAML_CFT,
      }))
    : undefined;
